import type { ReactNode } from "react";
import { Outlet } from "react-router";
import { usePortalMe } from "../../api/portal";
import { useAuth } from "../../auth/AuthProvider";
import { SignOutLink } from "../../auth/SignOutLink";
import { CrumbsProvider } from "../../app/crumbs";
import { PORTAL_NAV } from "../../app/nav";
import { Sidebar } from "../../app/Sidebar";
import { Topbar } from "../../app/Topbar";
import { APP_ROOT_ID } from "../../app/useRail";
import { Notice } from "../../design/components";
import styles from "./portal.module.css";

/** The reduced portal shell: one company, three sections, no switcher and no search. */
export function PortalLayout() {
  const { me } = useAuth();
  const portal = usePortalMe();
  const entity = portal.data?.entity;
  const pairs: [string, ReactNode][] = entity
    ? [
        ["CR", entity.crNumber],
        ["Participant", entity.participantId],
      ]
    : [];

  return (
    <div className={`app ${styles.shell}`} id={APP_ROOT_ID}>
      <Sidebar groups={PORTAL_NAV} role={me?.role ?? "readonly"} surface="portal" />
      <div className="main">
        <CrumbsProvider>
          <Topbar title={entity?.legalName} pairs={pairs} />
          <main className="page">
            {portal.isError ? (
              <Notice kind="fail">
                <p>Your company access is not active. Ask your company administrator.</p>
                <SignOutLink />
              </Notice>
            ) : (
              <Outlet />
            )}
          </main>
        </CrumbsProvider>
      </div>
    </div>
  );
}
